import { render, staticRenderFns } from "./VisualizarDocumento.vue?vue&type=template&id=15ff3fa2&scoped=true"
import script from "./VisualizarDocumento.vue?vue&type=script&lang=js"
export * from "./VisualizarDocumento.vue?vue&type=script&lang=js"
import style0 from "./VisualizarDocumento.vue?vue&type=style&index=0&id=15ff3fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ff3fa2",
  null
  
)

export default component.exports